import { render, staticRenderFns } from "./PromptHeader.vue?vue&type=template&id=5e189c10"
import script from "./PromptHeader.vue?vue&type=script&lang=js"
export * from "./PromptHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports